// HomeFeed.jsx (create this file)
import Post from "scenes/post/Post";

const HomeFeed = () => {
  return <Post />;
};

export default HomeFeed;
